import { pgEnum, pgTable, primaryKey, uuid, varchar } from "drizzle-orm/pg-core"
import { estates } from "./estate"
import { journals } from "./journal"
import { users } from "./users"

export const permissionRolesEnum = pgEnum("permission_roles_enum", ["ADMIN", "STANDARD"])

// Purpose: Links users to estates with a specific permission role.
export const userEstatePermissions = pgTable(
  "user_estate_permission",
  {
    userId: varchar("user_id", { length: 255 })
      .notNull()
      .references(() => users.id, { onDelete: "cascade" }),
    estateId: uuid("estate_id")
      .notNull()
      .references(() => estates.id, { onDelete: "cascade" }),
    role: permissionRolesEnum("permission_roles_enum").notNull(),
  },
  (table) => [primaryKey({ columns: [table.userId, table.estateId] })],
)

// Purpose: Links users to journals with a specific permission role.
export const userJournalPermissions = pgTable(
  "user_journal_permission",
  {
    userId: varchar("user_id", { length: 255 })
      .notNull()
      .references(() => users.id, { onDelete: "cascade" }),
    journalId: uuid("journal_id")
      .notNull()
      .references(() => journals.id, { onDelete: "cascade" }),
    role: permissionRolesEnum("permission_roles_enum").notNull(),
  },
  (table) => [primaryKey({ columns: [table.userId, table.journalId] })],
)
